import { render, staticRenderFns } from "./OptionalText.vue?vue&type=template&id=1609dc62"
import script from "./OptionalText.vue?vue&type=script&lang=js"
export * from "./OptionalText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports